type TripEditabilityInput = {
  creationSource: string;
  isEditable?: boolean | null;
  bookingStatus?: string | null;
};

type TripEditability = {
  isDateUnset: boolean;
  isReadOnly: boolean;
  canEditTripSelections: boolean;
};

export const deriveTripEditability = (
  overview: TripEditabilityInput | undefined,
  isTemplateDateUnset = false
): TripEditability => {
  const creationSource = overview?.creationSource ?? '';
  const bookingStatus = overview?.bookingStatus;
  const isBooked = bookingStatus === 'BOOKED' || bookingStatus === 'OUTSTANDING';
  const isDateUnset = isTemplateDateUnset;
  const isBlueprintOrPlayground =
    creationSource === 'FROM_TEMPLATE' ||
    creationSource === 'FROM_VIRTUAL_BLUEPRINT' ||
    creationSource === 'FROM_VIRTUAL_BLUEPRINT_TEMPLATE' ||
    creationSource.includes('PLAYGROUND');
  const isStructurallyEditable = overview?.isEditable ?? (!isBooked && (isDateUnset || isBlueprintOrPlayground));

  return {
    isDateUnset,
    isReadOnly: overview !== undefined && !isStructurallyEditable,
    canEditTripSelections: !isBooked && overview?.isEditable !== false
  };
};
